export default __webpack_public_path__ + "static/keeping-your-skin-fresh-on-a-long-haul-flight-honey-ddc28ce16b8ef3d990955167ea2ddcba.jpg";